import React from 'react'
import { observer } from 'mobx-react'

import UpdateStore from 'stores/update/UpdateStore'

import Dialog from 'components/dialog/Dialog'
import Button from 'components/button/Button'

import styles from './updateReadyDialog.scss'

interface IProps {
  onClose: () => void
}

@observer
export default class UpdateReadyDialog extends React.Component<IProps> {
  handleInstall() {
    UpdateStore.install()
  }

  render() {
    const { onClose } = this.props
    return (
      <Dialog
        className={styles.container}
        title="Updates ready"
        primaryButton={
          <Button
            green
            disabled={UpdateStore.isInstalling}
            onClick={this.handleInstall}
          >
            Install and restart
          </Button>
        }
        secondaryButton={
          <Button ghost className={styles.laterBtn} onClick={onClose}>
            Install Later
          </Button>
        }
      >
        <div className={styles.content}>
          <p className={styles.description}>
            New updates have been downloaded and are ready to be installed.
            Doing this will restart Studio.
            <br />
            <br />
            Your current session will be saved and restored after the
            installation.
          </p>
        </div>
      </Dialog>
    )
  }
}
